import { IonContent, IonPage, useIonViewDidEnter } from '@ionic/react'
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { saveDestinationAddress, setDestinationAddressDefaults } from '../store/destinationAddress.actions'
import RefRecAddress from '../../../components/address/RefRecAddress.component'
import { showAlert } from '../../../components/alert/store/alert.actions'
import { getZipSelector } from '../../../components/zip/selectors/zip.selector'
import { IDispositionState } from '../store/destinationAddress.types'
import { getDestinationAddressSelector } from '../selectors/destinationAddress.selectors'

const DestinationAddress: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const zip = useSelector(getZipSelector)
  const { alertMessage } = zip
  const { destination }: IDispositionState = useSelector(getDestinationAddressSelector)

  const onBackClick = () => {
    history.push(TabConstants.CHART_ROUTE)
  }

  const onSaveClick = () => {
    dispatch(saveDestinationAddress())
  }

  useIonViewDidEnter(() => {
    if (!destination?.__areDefaultsSet) {
      dispatch(setDestinationAddressDefaults(true))
    }
  }, [destination?.__areDefaultsSet])

  useEffect(() => {
    if (alertMessage) {
      dispatch(showAlert({ message: alertMessage }))
    }
  }, [dispatch, alertMessage])

  return (
    <IonPage id='DestinationAddressPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        isBackButton={true}
        nextLabel={t('common.buttons.Save')}
        nextOnClick={onSaveClick}
        title={t('destinationAddress.destinationAddress')}
      />
      <IonContent color='light'>
        <RefRecAddress isPHI addressTypeSelected={2} />
      </IonContent>
    </IonPage>
  )
}

export default DestinationAddress
